import { useState, MouseEvent } from 'react';
import cm from 'classnames';

import { ReactComponent as PlusIcon } from 'assets/ui/plus.svg';
import { ReactComponent as MinusIcon } from 'assets/ui/minus.svg';

import styles from './clip-error-status-bar.module.scss';

interface Props {
  errorClips: ClipId[];
  handleClick: (clipId: ClipId) => void;
}

export const ClipErrorStatusBar = ({ errorClips, handleClick }: Props) => {
  const [isOpen, setOpen] = useState(false);

  const onClick = (e: MouseEvent<HTMLLIElement>, clipId: ClipId) => {
    e.stopPropagation();
    handleClick(clipId);
  };

  if (!errorClips.length) return null;
  return (
    <div className={cm(styles.ErrorBar, { [styles['ErrorBar--open']]: isOpen })} onClick={() => setOpen(!isOpen)}>
      <h4>
        {isOpen ? <MinusIcon /> : <PlusIcon />}
        <span>Errors ({errorClips.length})</span>
      </h4>
      <ul>
        {errorClips.map((clipId: ClipId) => (
          <li key={clipId} onClick={(e) => onClick(e, clipId)}>
            {clipId}
          </li>
        ))}
      </ul>
    </div>
  );
};
